export default __webpack_public_path__ + "static/media/Trinity College.895bc4f0.png";